






















































































































import { JournalEntry } from "../../models/JournalEntry";
import AttachmentsDropdown from "./AttachmentsDropdown.vue";
import EntryValidationCheckbox from "../entry_detail/EntryValidationCheckbox.vue";
import FacturationModal from "../../intervention/FacturationModal.vue";
import AbsenceModal from "../../employe/AbsenceModal.vue";
import InterventionModal from "../../intervention/InterventionModal.vue";
import { Contact } from "../../models/Contact";
import EAttachmentType = JournalEntry.EAttachmentType;

export default {
    name: "JournalTaskLine",
    components: {
        EntryValidationCheckbox,
        AttachmentsDropdown,
        FacturationModal,
        AbsenceModal,
        InterventionModal,
    },
    props: {
        entry: JournalEntry,
    },
    data() {
        return {
            facturationModal: {
                interventionId: null,
            },
            absenceModal: {
                absenceId: null,
                employeId: null,
            },
            interventionModal: {
                interventionId: null,
            },
        };
    },
    computed: {
        categoryName(): string {
            return JournalEntry.CategoryName[this.entry.category] || "";
        },
        isCoproprieteSensible(): boolean {
            return (
                this.entry.client &&
                this.entry.client.hasTag(Contact.ETag.CoproprieteSensible)
            );
        },
        seeMore(): boolean {
            return this.entry.short_desc != this.entry.description;
        },
        isFacturation(): boolean {
            return this.entry.attachment_type === EAttachmentType.Facturation;
        },
        // Absence en corbeille (ou supprimée) : plus rien à ouvrir.
        isAbsence(): boolean {
            return (
                this.entry.attachment_type === EAttachmentType.Absence &&
                !!this.entry.attachment
            );
        },
        isIntervention(): boolean {
            return this.entry.attachment_type === EAttachmentType.Intervention;
        },
    },
    methods: {
        showEntry(): void {
            this.$emit(
                "action",
                JournalEntry.UIActionType.show_entry,
                this.entry
            );
        },
        showFacturation(): void {
            this.facturationModal.interventionId =
                this.entry.attachment.intervention_id;
        },
        onFacturationModalClose(): void {
            this.facturationModal.interventionId = null;
        },
        showAbsence(): void {
            this.absenceModal.absenceId = this.entry.attachment.id;
            this.absenceModal.employeId = this.entry.attachment.employe_id;
        },
        onAbsenceModalClose(): void {
            this.absenceModal.absenceId = null;
            this.absenceModal.employeId = null;
        },
        showIntervention(): void {
            this.interventionModal.interventionId = this.entry.attachment_id;
        },
        onInterventionModalClose(): void {
            this.interventionModal.interventionId = null;
        },
    },
};
